import React from "react";
import ClassNames from "classnames";
import styles from "./index.module.scss";
import AccessTimeIcon from "@material-ui/icons/AccessTime";
import CalendarTodayIcon from "@material-ui/icons/CalendarToday";

import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  DatePicker,
  TimePicker,
} from "@material-ui/pickers";

export default function DatePickerGroup({
  handleDateChange,
  selectedDate,
  minDate = undefined,
  maxDate = undefined,
  disabled,
  ...props
}) {
  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <div className={ClassNames(styles.pickerGroup, props.className)}>
        <div className={styles.datePickerContainer}>
          <AccessTimeIcon className={styles.pickerIcon} fontSize="inherit" />
          <DatePicker
            disableToolbar
            variant="inline"
            disableFuture={props.disableFuture}
            disablePast={props.disablePast}
            className={styles.datePicker}
            format="dd/M/yyyy"
            onChange={handleDateChange}
            autoOk={true}
            value={selectedDate}
            animateYearScrolling
            minDate={minDate}
            maxDate={maxDate}
            disabled={disabled}
          />
        </div>

        <div className={styles.timePickerContainer}>
          <CalendarTodayIcon className={styles.pickerIcon} fontSize="inherit" />
          <TimePicker
            variant="inline"
            className={styles.timePicker}
            autoOk
            value={selectedDate}
            onChange={handleDateChange}
            disabled={disabled}
          />
        </div>
      </div>
    </MuiPickersUtilsProvider>
  );
}
